export default "__VITE_ASSET__C$lGmovt__"